import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import DynamicTable from "../../../Components/Common/DynamicTable";
import EastIcon from "@mui/icons-material/East";
import { restructureData } from "../../../utils/restructureData";
import { get, put } from "../../../utils/api";
import { validateOptionalTable } from "../../../utils/validateTable";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure22 = ({ hide, downloadMode = false }) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
console.log(id,"id")
  const entityData = [
    {
      fieldName: "listOfAllEntities",
      title:
        "a. Provide a list of all entities included in your organization's sustainability reporting",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "entityName",
          title: "Entity Name",
          type: "text",
          placeholder: "Enter Text",
          default: "name",
          width: "82%",
        },
      ],
    },
  ];

  const auditData = [
    {
      fieldName: "auditedConsolidatedFinancialStatement",
      title:
        "b. If your organization has audited consolidated financial statements or financial information filled on public record,  specify any differences between the list of entities included in your financial reporting and those included in your sustainability reporting.",
      type: "array",
      letter: "b.",
      fields: [
        {
          fieldName: "entityName",
          title: "Entity Name",
          type: "text",
          placeholder: "Enter Text",
          width: "30%",
        },
        {
          fieldName: "distance",
          title: "Reason For Distance",
          type: "text",
          placeholder: "Enter Text",
          width: "52%",
        },
      ],
    },
  ];

  const questionData = [
    {
      fieldName: "minorityInterest",
      title:
        "i. Does the approach involve adjustments to information for minority interests?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "disposalOfEntity",
      title:
        "ii. How does the approach consider mergers, acquisitions, and disposal of entities or parts of entities?",
      type: "text",
      placeholder: "Enter Text",
    },
    {
      fieldName: "matrialTopics",
      title:
        "iii. Does the approach differ across the disclosures in this Standard and across material topics?",
      type: "text",
      placeholder: "Enter Text",
    },
  ];

  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 =
        res?.data?.data?.GeneralDisclosures2021?.orgSustainabilityReport;
      setData(res1);
      if (
        res?.data?.data?.year ? res?.data?.data?.year < currentYear - 1 : false
      )
        setDisabled(true);
      console.log(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      minorityInterest: data?.consolidatingInformations?.minorityInterest || "",
      disposalOfEntity: data?.consolidatingInformations?.disposalOfEntity || "",
      matrialTopics: data?.consolidatingInformations?.matrialTopics || "",
    });
  }, [data]);

  const [errors, setErrors] = useState({});
  const [auditErrors, setAuditErrors] = useState({});
  const [entityErrors, setEntityErrors] = useState({});
  const [entityTable, setEntityTable] = useState([]);
  const [auditTable, setAuditTable] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = `This field is Required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateOptionalTable(entityData, entityTable, setEntityErrors);
      let v2 = validateOptionalTable(auditData, auditTable, setAuditErrors);

      if (!validateForm() || !v1 || !v2) return;

      let transformedData2 = {
        orgSustainabilityReport: {
          consolidatingInformations: formData,
          ...restructureData(entityTable),
          ...restructureData(auditTable),
        },
        submitted2_2: true,
        type: "GeneralDisclosures2021",
      };
      console.log("abc", transformedData2);

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-3/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-3/${id}`);
    }
  };
  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0rem" }}
      >
        2-2 Entities included in the organization's sustainability reporting
      </p>
      {/* 1 */}
      <DynamicTable
        {...{
          inputData: entityData,
          tables: entityTable,
          setTables: setEntityTable,
          errors: entityErrors,
          disabled: disabled,
          setErrors: setEntityErrors,
          data,
          hide,
        }}
      />
      <DynamicTable
        {...{
          inputData: auditData,
          tables: auditTable,
          setTables: setAuditTable,
          disabled: disabled,
          errors: auditErrors,
          setErrors: setAuditErrors,
          data,
          hide,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <p
        className={styles.ques_heading}
        style={{ marginBottom: hide ? "-1.5rem" : "0rem" }}
      >
        c. When consolidating information for multiple entities, explain the
        approach used, including:
      </p>
      <Box sx={{ ml: 2 }}>
        {questionData.map((el) => (
          <Box>
            <p className={styles.ques_heading}>{el.title}</p>
            <Box sx={{ ml: 2 }}>
              <InputField
                placeholder={"Enter Text"}
                fieldName={el.fieldName}
                mt="-5px"
                disabled={disabled}
                value={formData?.[el.fieldName]}
                handleChange={handleChange}
                errors={errors[el.fieldName] && true}
              />
              <p
                color="error"
                variant="caption"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el.fieldName]}
              </p>
            </Box>
          </Box>
        ))}
      </Box>
      {/* 2 */}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox
                  url={`/gri/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure22;
